import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import type { SectionMenu } from "components";
import type { Appointment, CarCheck } from "models";

export type HoldingAppointmentDetailsScrollToSectionMenus = {
  details: SectionMenu;
  interventions: SectionMenu;
  checks: SectionMenu;
};

export const useScrollToSectionMenus = (appointment?: Appointment, checks?: CarCheck[]) => {
  const { t, ready } = useTranslation();

  return useMemo(
    (): HoldingAppointmentDetailsScrollToSectionMenus => ({
      details: { id: "details", icon: "circle exclamation", title: t("v8_car_customer_details", "Car & Customer details"), showEmpty: true },
      interventions: {
        id: "interventions",
        icon: "screwdriver wrench",
        title: t("v8_interventions", "Interventions"),
        count: appointment?.interventions?.length ?? 0,
        showEmpty: true
      },
      checks: { id: "checks", icon: "list", title: "", count: checks?.length }
    }),
    [ready, appointment, checks]
  );
};
